import React from 'react';


//Returns
function Returns() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">


     

      {/*  Page content */}
      <main className="flex-grow">

        <section className="bg-grey-900">
          <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="pt-32 pb-12 md:pt-40 md:pb-20">

              {/* Page header */}
              <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
                <h1 className="h1 mb-4 text-white">Return Policy</h1>
                <p className="text-xl text-white">Last updated June 16, 2021</p>
              </div>
              <p className="text-xl text-white">All sales are final. We do not offer refunds in any circumstances. For any questions or inquiries, email contact@divinebots.com</p>
              
              

            </div>
          </div>
        </section>

      </main>

    </div>
  );
}

export default Returns;